/**
 * @generated SignedSource<<1eba7678bba8759487f6c9a0fa9b3b4e>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "Stripe__ReSubscribePayload",
    "kind": "LinkedField",
    "name": "stripeReSubscribe",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "error",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "StripeReSubscribeMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "StripeReSubscribeMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "d107b839b6b252024840bea7933cd6a7",
    "id": null,
    "metadata": {},
    "name": "StripeReSubscribeMutation",
    "operationKind": "mutation",
    "text": "mutation StripeReSubscribeMutation(\n  $input: Stripe__ReSubscribeInput!\n) {\n  stripeReSubscribe(input: $input) {\n    success\n    error\n  }\n}\n"
  }
};
})();

node.hash = "673945d62c26c9fd46c54828ea45eddc";

module.exports = node;
